import { render } from "./ProductGroupWrapper.vue?vue&type=template&id=54e80f38"
import script from "./ProductGroupWrapper.vue?vue&type=script&lang=js"
export * from "./ProductGroupWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__